module.exports = __webpack_public_path__ + "img/pzlx3@3x.15ad1f4c.png";